/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type SVGProps } from 'react';
import { cn } from '@/lib/utils';

/**
 * Black Magic filled diagonal up-right arrow (↗) — the brand arrow shown beside section titles
 * (e.g. Featured Products). Distinct from the thin `lucide-react` `ArrowRight` used in CTAs.
 * Path is the exact Figma asset; `fill="currentColor"` so it inherits the surrounding text color
 * (and therefore flips with the Default Settings light/dark theme).
 */
export function ArrowUpRightIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 25 25" fill="currentColor" aria-hidden="true" className={cn('size-6', className)} {...props}>
            <path d="M19.9784 16.4256V1.77521H25V22.4892C24.9997 23.1547 24.735 23.7938 24.2644 24.2644C23.7937 24.735 23.1548 24.9999 22.4892 25H1.77521V19.9784H16.428L0 3.55041L3.55041 0L19.9784 16.4256Z" />
        </svg>
    );
}
